// extracted by mini-css-extract-plugin
module.exports = {"jobCard-infoList":"jobCard-infoList","jobCard-info":"jobCard-info","jobCard-info__title":"jobCard-info__title","jobCard-info__content":"jobCard-info__content"};